/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import {
  DraftsOutlined,
  EmailOutlined,
  FaxOutlined,
  PersonOutlined,
  PhoneOutlined,
} from "@mui/icons-material";

import { ActivityType } from "../api/types/types";

export const getActivityTypeIconById = (idType: ActivityType) => {
  switch (idType) {
    case ActivityType.Phone:
      return <PhoneOutlined />;
    case ActivityType.Appointment:
      return <PersonOutlined />;
    case ActivityType.Letter:
      return <DraftsOutlined />;
    case ActivityType.Fax:
      return <FaxOutlined />;
    case ActivityType.Email:
      return <EmailOutlined />;
    default:
      return <PersonOutlined />;
  }
};
